import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/app/Disclaimer.css';
import WhatsAppBanner from './WhatsAppBanner';
import Nav from './Nav';

const Disclaimer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <WhatsAppBanner />
      <Nav />
      <section className="disclaimer-section">
        <div className="disclaimer-container">
          <h1>{t('disclaimer.title')}</h1>

          <h2>{t('disclaimer.accuracyOfInformation.title')}</h2>
          <p>
            {t('disclaimer.accuracyOfInformation.paragraph')}
          </p>

          <h2>{t('disclaimer.professionalAdvice.title')}</h2>
          <p>
            {t('disclaimer.professionalAdvice.paragraph')}
          </p>

          <h2>{t('disclaimer.serviceAvailability.title')}</h2>
          <p>
            {t('disclaimer.serviceAvailability.paragraph')}
          </p>

          <h2>{t('disclaimer.thirdPartyLinks.title')}</h2>
          <p>
            {t('disclaimer.thirdPartyLinks.paragraph')}
          </p>

          <h2>{t('disclaimer.changesToDisclaimer.title')}</h2>
          <p>
            {t('disclaimer.changesToDisclaimer.paragraph')}
          </p>
        </div>
      </section>
    </>
  );
};

export default Disclaimer;
